export function classifyTenantNotification(notification) {
  if (!notification) return null;

  const type = String(notification.type || '').toLowerCase();
  const actionRequired = notification.requiresAction === true || notification.actionRequired === true;

  if (type.startsWith('termination_')) {
    return 'mijnPand';
  }

  if (
    type.includes('contract') ||
    type.includes('amendment') ||
    type === 'senttotenant' ||
    type === 'sent'
  ) {
    return 'contracts';
  }

  if (
    type.includes('viewing') ||
    type.includes('visit') ||
    type === 'viewing_request' ||
    type === 'motivation_reminder'
  ) {
    return 'viewings';
  }

  if (
    type === 'property_notification' ||
    type === 'problem_response' ||
    type === 'property_report' ||
    type === 'property_problem_reported' ||
    type.includes('problem') ||
    type === 'payment_action_required' ||
    type === 'payment_reminder' ||
    type === 'payment_marked_paid' ||
    type === 'maintenance_confirmation' ||
    type === 'document_signature_required' ||
    actionRequired
  ) {
    return 'mijnPand';
  }

  // Fallback: unknown types with a propertyId → mijnPand, otherwise ignored
  if (notification.propertyId) return 'mijnPand';
  return null;
}

export function countTenantNotificationBuckets(notifications) {
  const counts = { contracts: 0, viewings: 0, mijnPand: 0 };

  notifications.forEach((notification) => {
    const bucket = classifyTenantNotification(notification);
    if (bucket) counts[bucket] += 1;
  });

  return counts;
}

export function mergeNotificationDocs(...docGroups) {
  const merged = new Map();

  docGroups.flat().forEach((doc) => {
    if (!doc) return;
    merged.set(doc.id, doc);
  });

  return Array.from(merged.values());
}
